const EXAMS_EVENTS_PATHS = [
  "/timetable/operational-planning",
  "/timetable/examinations",
  "/timetable/events-duties",
];

const matchesPath = (pathname, prefix) => pathname === prefix || pathname.startsWith(`${prefix}/`);

export const navigationOwnerForPath = (pathname) => {
  if (EXAMS_EVENTS_PATHS.some((path) => matchesPath(pathname, path))) return "examsEvents";
  if (matchesPath(pathname, "/timetable/management-overview")) return "reports";
  return null;
};

export const navigationEntryForPath = (submodules, pathname, owner) => {
  const baseurl = owner === "examsEvents" ? "/exams-events" : "/reports/:id";
  const entry = submodules.find(([base]) => base === baseurl);
  return entry?.[2]?.some(({ url }) => matchesPath(pathname, url)) ? entry : null;
};
